import { z } from 'zod';

export const noteSchema = z.object({
  publicId: z.guid().optional(),
  concurrencyId: z.string().optional(),
  expirationDatetimeUtc: z.string(),
  externalInformationUrl: z.string(),
  isVisible: z.boolean(),
  title: z.string(),
  content: z.string(),
});

export type Note = z.infer<typeof noteSchema>;
